import { useState, SyntheticEvent } from 'react';
import { Grid, Typography, Tab, Box, Paper, Button } from "@mui/material";
import TabPanel from '@mui/lab/TabPanel';
import LastUpdateTable from "./LastUpdateTable";
import { TabContext, TabList } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import EyeIcon from "@mui/icons-material/Visibility";
import StatsFurnitureTree from './StatsFurnitureTree';
import { download } from 'queries/http';

const DownloadButton = ({ className, href, fileName, children }: { className: string, href: string, fileName: string, children: any }) => {
  const onClick = () => {
    download(href, fileName);
  };
  return <Button className={className} onClick={onClick} variant="text" children={children} />;
};

const StatsIndexPage = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState('1');

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const getHrefDownload = (value: string) => {
    let hrefValue: string = '';
    switch (value) {
      case "1":
        hrefValue = '/api/statistics/shop/';
        break;
      default:
        hrefValue = '/api/statistics/furniture/';
        break;
    }
    return hrefValue;
  };

  const getFileName = (value: string) => {
    let fileName: string = '';
    switch (value) {
      case "1":
        fileName = t("stats.index.download.lastUpdateTable");
        break;
      default:
        fileName = t("stats.index.download.statsFurnitureTree");
        break;
    }
    return fileName;
  };

  return (
    <Grid container spacing={2} direction="column">
      <Grid item>
        <Typography component="h1" variant="h6">
          Stats
        </Typography>
      </Grid>
      <Grid item sx={{ maxWidth: { xs: "90%!important", lg: "1000px", xl: "1200px" } }}>
        <Paper sx={{ width: "100%", p: 2, pb: 6 }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
              <TabList onChange={handleChange} aria-label={t("a11y.statsTabs")}>
                <Tab label={t("stats.index.lastUpdateTable.title")} value="1" />
                <Tab label={t("stats.index.statsFurnitureTree.title")} value="2" />
              </TabList>
              <DownloadButton
                className={"stats-download"}
                href={getHrefDownload(value)}
                fileName={getFileName(value)}
              >
                <EyeIcon />{t("stats.index.download.title")}
              </DownloadButton>
            </Box>
            <TabPanel value="1" sx={{ height: "auto" }}>
              <LastUpdateTable />
            </TabPanel>
            <TabPanel value="2" sx={{ height: "auto" }} className="stat-furniture">
              <StatsFurnitureTree />
            </TabPanel>
          </TabContext>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default StatsIndexPage;
